var render = function render(){var _vm=this,_c=_vm._self._c;return _c('body',{attrs:{"id":"app"}},[(!_vm.isLoginPage)?_c('HeaderCollapsible',{attrs:{"id":"header","links":_vm.routes,"account":_vm.isAccountVisible}}):_vm._e(),_c('router-view'),(!_vm.isLoginPage)?_c('FooterFixed',{attrs:{"id":"footer"}}):_vm._e(),_c('ToastNotification'),_c('v-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }